import { appendScript } from '../utils/DomUtils';

export const BEACON_SCRIPT_ID = 'riskified-beacon';

/**
 * Dynamically constructs and injects the Riskified Beacon script.
 *
 * The base URL is provided via the `beacon_script` data-config key
 * (e.g. `https://beacon.riskified.com?shop=<DOMAIN>`) and the runtime
 * `trans_order_id` is appended as the `sid` query parameter.
 *
 * The script is only injected when the `beacon_script` config is present.
 * It is appended to the document `<head>` and loads async (non-blocking)
 * so it has no impact on checkout rendering performance.
 */
class InjectBeaconScriptUseCase {
  private beaconScript: string | undefined;

  private transOrderId: number;

  constructor(beaconScript: string | undefined, transOrderId: number) {
    this.beaconScript = beaconScript;
    this.transOrderId = transOrderId;
  }

  public execute(): void {
    if (!this.beaconScript) {
      return;
    }

    const src = `${this.beaconScript}&sid=${this.transOrderId}`;

    appendScript({ src }, BEACON_SCRIPT_ID, 'head');
  }
}

export default InjectBeaconScriptUseCase;
